import CommunicationModal from './CommunicationModal';

export default CommunicationModal;
